import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ConversationsContext } from '#providers/conversations/Conversations.context.ts';
import type { TConversationsContextValue } from '#providers/conversations/Conversations.types.ts';

export const useConversations = (): TConversationsContextValue =>
  useRequiredContext(
    ConversationsContext,
    'useConversations is only available inside a ConversationsProvider',
  );
